import { Link } from '@tiptap/extension-link';

/**
 * Ссылки, поставленные в редакторе админки, приходят в описании как mark `link`.
 * generateHTML падает на неизвестной марке, поэтому расширение нужно везде, где описание рендерится.
 *
 * В превью (карточки новостей и списки) описание уже обёрнуто в ссылку на саму новость,
 * поэтому вложенный <a> ломал бы вёрстку и уводил бы не туда — там марка рендерится как обычный текст.
 */
export const PlainTextLink = Link.extend({
  renderHTML() {
    return ['span', 0];
  },
});
